import { Toolbar, ToolbarButton, ToolbarGroup } from "@fluentui/react-components";
import { AddRegular, ArrowClockwise24Regular, DeleteRegular, DismissRegular, EditRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";

// Business logic
import { useSelectedSitesContext } from "../context/SelectedSiteContext";

const SitesToolbar = ({ setIsAddOpen, setIsEditOpen, setIsRemoverOpen }) => {
  const { t } = useTranslation();
  const { value: selectedSites, setValue: setSelectedSites } = useSelectedSitesContext();
  const queryClient = useQueryClient();

  const handleClickNew = () => {
    setIsAddOpen(true);
  };
  const handleClickEdit = () => setIsEditOpen(true);

  return (
    <Toolbar>
      <ToolbarGroup>
        <ToolbarButton icon={<AddRegular />} aria-label="Add" onClick={handleClickNew}>
          {t("generic.add")}
        </ToolbarButton>
        <ToolbarButton
          disabled={!(selectedSites?.length === 1)}
          icon={<EditRegular />}
          aria-label="Edit"
          onClick={handleClickEdit}
        >
          {t("generic.edit")}
        </ToolbarButton>
        <ToolbarButton
          disabled={!(selectedSites?.length === 1)}
          icon={<DeleteRegular />}
          aria-label="Delete"
          onClick={() => setIsRemoverOpen(true)}
        >
          {t("generic.delete")}
        </ToolbarButton>
        <ToolbarButton
          icon={<ArrowClockwise24Regular />}
          onClick={() => queryClient?.invalidateQueries({ queryKey: ["sites"] })}
        >
          {t("generic.refresh")}
        </ToolbarButton>
        <ToolbarButton
          disabled={!(selectedSites?.length > 0)}
          icon={<DismissRegular />}
          onClick={() => setSelectedSites([])}
        >
          {t("generic.unselect")}
        </ToolbarButton>
      </ToolbarGroup>
      {selectedSites && <span>{selectedSites.code}</span>}
    </Toolbar>
  );
};

export default SitesToolbar;
